// global.SET_API_URL = 'http://localhost:5000/'

// global.SET_API_URL = 'https://server.lb.whdevs.com/'

// global.SET_API_URL = 'http://98.90.41.32:5001/'

// global.SET_API_URL = 'http://192.168.10.2:5000/'

// global.SET_API_URL = 'http://192.168.100.94:5000/'

global.SET_API_URL = 'https://server-nms.whdevs.com/'

global.COMPANY_NAME = 'WORLD HOME DEVELOPMENT'

global.targetDate = new Date()
